<template>
  <div class="page">
    <form @keyup.enter="signUp">
      <ion-grid class="page-content">
        <ion-row>
          <ion-col class="col-padding ion-text-center">
            <img src="/assets/images/logo/rapid.png" alt="Rapid Logo" class="logo" />
          </ion-col>
        </ion-row>
        <ion-row class="rectangle-round">
            <ion-col>
              <ion-row>
                <ion-col class="col-padding">
                  <ion-label class="border-text" position="stacked">Name<span class="required">*</span></ion-label>
                    <div class="border-line">
                      <ion-input
                        class="form-input"
                        type="text"
                        id="name"
                        placeholder="Enter Your Name"
                        @input="name = $event.target.value"
                        maxlength="200"
                      ></ion-input>
                    </div>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="col-padding">
                  <ion-label class="border-text" position="stacked">Mobile Number <span class="required">*</span></ion-label>
                    <div class="border-line">
                      <ion-input
                      class="form-input"
                      type="tel"
                      id="mobile"
                      placeholder="Enter Mobile Number"
                      @input="mobile = $event.target.value"
                      maxlength="10"
                    ></ion-input>
                    </div>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="ion-text-center">
                  <h6 class="accept-terms">By Signing In you accept to RapidEVCharge</h6>
                  <span class="dark-text ">
                    <div class="terms-item">
                      <div class="terms-condition">
                        <ion-checkbox v-model="acceptedTerms" @ionChange="onTermsChange"></ion-checkbox>
                        <span>
                          I agree to the
                          <a :href="termsAndConditionLink" target="_blank">
                            Terms & Conditions
                          </a>
                        </span>
                      </div>
                    </div>
                    <!-- <div class="terms-item">
                      <ion-checkbox label-placement="end" v-model="acceptedTerms" @ionChange="onTermsChange">I agree to the
                        <a :href="termsAndConditionLink" target="_blank">
                          Terms &amp; Conditions
                        </a></ion-checkbox> -->
                    <!-- </div> -->
                    <p v-if="showError" style="color: red; font-size: 13px;">
                    Please accept Terms & Conditions
                  </p>
                    <!-- <a :href="this.termsAndConditionLink" target="_blank" >Terms &amp; Conditions</a> -->
                  </span>
                </ion-col>
              </ion-row><br>
              <ion-row>
                <ion-col>
                  <ion-button class="btn-primary" expand="block" @click="generateOtp" >Generate OTP</ion-button> 
                </ion-col>
              </ion-row>
              <ion-row class="ion-text-center">
                <ion-col>
                  <p>Already have an account? <span class="signIn" @click="gotoLogin">SignIn</span></p>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        <!-- <ion-row class="row-divider"></ion-row>
        <ion-row class="rectangle">
          <ion-col>
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  Mobile Number
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="tel"
                    id="mobile"
                    placeholder="Enter Mobile Number"
                    @input="mobile = $event.target.value"
                    maxlength="10"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">Email Address</ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="email"
                    placeholder="Enter Email Address"
                    @input="email = $event.target.value"
                    maxlength="200"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  First Name
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="text"
                    id="firstName"
                    placeholder="Enter First Name"
                    @input="firstName = $event.target.value"
                    maxlength="200"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  Last Name
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="text"
                    id="lastName"
                    placeholder="Enter Last Name"
                    @input="lastName = $event.target.value"
                    maxlength="200"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  Gender
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line select-mobile">
                  <ion-select
                    class="form-select"
                    id="gender"
                    :value="gender"
                    @ionChange="gender = $event.target.value"
                    placeholder="Select Gender"
                    interface="action-sheet"
                  >
                    <ion-select-option
                      v-for="(gender, index) in this.genders"
                      :key="index"
                      :value="gender.code"
                    >{{gender.description ? gender.description : gender.code}}</ion-select-option>
                  </ion-select>
                </div>
                <div class="border-line select-web">
                    <select class="input-select" v-model="gender" placeholder="Select Gender">
                      <option
                        v-for="(gender, index) in this.genders"
                        :key="index"
                        :value="gender.code"
                      >{{gender.description}}</option>
                    </select>
                  </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  Date of Birth
                  <span class="required">*</span>
                </ion-label>
                <div class="date-picker-box-rc datepicker-web">
                  <datepicker 
                    v-model="dob" 
                    inputFormat="dd/MMM/yyyy" 
                    class="form-vue-picker"
                    placeholder="DD/MON/YYYY" 
                    typeable=true 
                  />
                  <span class="custom-calendar-icon">
                    <img src="/../assets/images/common/datepicker/calendar.png" />
                  </span>
                </div>
                <div class="border-line datepicker-mobile">
                    <datepicker 
                    v-model="dob" 
                    class="form-picker" 
                    inputFormat="dd/MMM/yyyy" 
                    placeholder="Select Date of birth"
                    :readonly="true"
                  />
                  <span class="input-icon-calendar">
                    <img src="/../assets/images/common/datepicker/calendar.png" />
                  </span>
                </div>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col class="col-padding">
                <ion-label class="secondary-text">Password</ion-label>
              </ion-col>
            </ion-row> 
            <ion-row align-items-stretch>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  Password
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    type="password"
                    id="password"
                    placeholder="Min 8 Chars,1 Uppercase, 1 Spl Char"
                    @input="password = $event.target.value"
                    maxlength="50"
                  ></ion-input>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" class="col-padding">
                <ion-label class="border-text" position="stacked">
                  Retype Password
                  <span class="required">*</span>
                </ion-label>
                <div class="border-line">
                  <ion-input
                    class="form-input"
                    id="retypePassword"
                    type="password"
                    placeholder="Min 8 Chars,1 Uppercase, 1 Spl Char"
                    @input="retypePassword = $event.target.value"
                    maxlength="50"
                  ></ion-input>
                </div>
              </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
              <ion-col size="12" class="col-padding">
                <ion-checkbox @ionChange="onTermsCons($event)"></ion-checkbox>
                <ion-label position="stacked" class="t-c">
                  <span class="required">*</span>
                  <span class="light-text">I agree to the</span>
                  <span class="dark-text">
                    <a :href="this.termsAndConditionLink" target="_blank">Terms &amp; Conditions</a>
                  </span>
                </ion-label>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row> -->
      </ion-grid>
      <!-- <div text-center>
        <ion-row>
          <ion-col class="col-padding">
            <ion-button expand="block" class="btn-primary" @click="signUp">GENERATE OTP</ion-button>
          </ion-col>
          <ion-col class="col-padding">
            <ion-button expand="block" class="btn-primary" @click="gotoLogin">Cancel</ion-button>
          </ion-col>
        </ion-row>
      </div> -->
    </form>
  </div>
</template>
  
<script>
import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonInput, IonDatetime, IonSelectOption, IonSelect, IonDatetimeButton, IonModal, IonCheckbox, alertController} from "@ionic/vue";

import moment from "moment";
import { config } from "../../config";
import { AuthenticationService } from "../../service/account/authenticator.service";
import { ProfilerService } from "../../service/profile/profiler.service";

import { Credential, NewCredential } from "../../entity/authentication/credential";
import { Profile, Gender, NewProfile } from "../../entity/authentication/profile";

import { ValidationUtils } from "../../util/validation-utils";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import datepicker from 'vue3-datepicker'
import { defineComponent } from "vue";
// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";

export default defineComponent({
  name: "signup",
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    IonLabel,
    IonInput,
    IonDatetime,
    IonSelectOption, 
    IonSelect,
    datepicker,
    IonDatetimeButton, 
    IonModal,
    IonCheckbox,
    alertController
  },

  async mounted() {
    // let genders = await new ProfilerService().genders();
    // this.genders = genders;
  },

  data: () => ({
    maxYear: moment()
      .add(-18, "year")
      .format(),
    genders: "",
    mobile: "",
    name: "",
    email: "",
    firstName: "",
    lastName: "",
    gender: "",
    dob: "",
    password: "",
    retypePassword: "",
    termsCons: false,
    acceptedTerms: false,
    showError: false,
    termsAndConditionLink: config.api.host + "/common/static/images/tnc.html"
  }),

  methods: {
    onTermsCons(event) {
      this.termsCons = event.detail.checked;
    },
    gotoLogin() {
      this.$router.push("/login");
    },
    onTermsChange() {
      if (this.acceptedTerms) {
        this.showError = false;
      }
    },
    async generateOtp() {
      try {
        if(typeof this.name === "undefined" ||
          this.name === null ||
          this.name === "" ||
          this.name.trim().length === 0) {
            new ToastUtils().presentToast("Enter Your Name");
            document.getElementById("name").setFocus();
        } else if (
          typeof this.mobile === "undefined" ||
          this.mobile === null ||
          this.mobile === "" ||
          this.mobile.trim().length === 0
        ) {
          new ToastUtils().presentToast("Enter Mobile Number");
          document.getElementById("mobile").setFocus();
        } else if (new ValidationUtils().mobile(this.mobile) === false) {
          new ToastUtils().presentToast("Enter Valid Mobile Number");
          document.getElementById("mobile").setFocus();
        } else {
          if (!this.acceptedTerms) {
            this.showError = true;
            this.loaderTab = false;
            return;
          }

          this.showError = false;
          let user = await new AuthenticationService().newSignupUserWithCredentialProfile(
            new NewCredential(this.mobile),
            new NewProfile(this.name.trim()) 
          )
          new ToastUtils().presentToast("OTP sent to your mobile number.");
          window.localStorage.setItem("user.id", user.id);
          window.localStorage.setItem("user.name", this.name);
          window.localStorage.setItem("user.mobile", this.mobile);

          this.$router.push("/signupverification");
        }
      } catch (error) {
        //SCMT 2.0 Start
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        // let serviceError = tryParseServiceError(error);
        //SCMT 2.0 End
        // new modify
        // if (error.response.data.errors[0].code === "U10001") {
        //   this.presentAlertConfirm(error.response.data.errors[0].detail, "U");
        // } else if (error.response.data.errors[0].code === "U10002") {
        //   this.presentAlertConfirm(error.response.data.errors[0].detail, "C");
        // } else {
        //   new AlertUtils().presentAlert(error.response.data.errors[0].detail);
        // }
        let serviceError = migratedTryParseServiceError(error);
          // new ToastUtils().presentToast(serviceError.description);
          if (serviceError.code === "U10001") {
          this.presentAlertConfirm(serviceError.description, "U");
        } else if (serviceError.code === "U10002") {
          this.presentAlertConfirm(serviceError.description, "C");
        } else {
          new ToastUtils().presentToast(serviceError.description);
        }
      }
    },
    async signUp() {
      try {
        if (
          typeof this.mobile === "undefined" ||
          this.mobile === null ||
          this.mobile === "" ||
          this.mobile.trim().length === 0
        ) {
          new ToastUtils().presentToast("Enter Mobile Number");
          document.getElementById("mobile").setFocus();
        } else if (new ValidationUtils().mobile(this.mobile) === false) {
          new ToastUtils().presentToast("Enter Valid Mobile Number");
          document.getElementById("mobile").setFocus();
        } else if (
          this.email !== "" &&
          new ValidationUtils().email(this.email) === false
        ) {
          new ToastUtils().presentToast("Enter Valid Email Address");
        } else if (
          typeof this.firstName === "undefined" ||
          this.firstName === null ||
          this.firstName === "" ||
          this.firstName.trim().length === 0
        ) {
          new ToastUtils().presentToast("Enter First Name");
          document.getElementById("firstName").setFocus();
        } else if (
          typeof this.lastName === "undefined" ||
          this.lastName === null ||
          this.lastName === "" ||
          this.lastName.trim().length === 0
        ) {
          new ToastUtils().presentToast("Enter Last Name");
          document.getElementById("lastName").setFocus();
        } else if (
          typeof this.gender === "undefined" ||
          this.gender === null ||
          this.gender === ""
        ) {
          new ToastUtils().presentToast("Select Gender");
        } else if (
          typeof this.dob === "undefined" ||
          this.dob === null ||
          this.dob === ""
        ) {
          new ToastUtils().presentToast("Enter Date of birth");
        } else if (
          typeof this.password === "undefined" ||
          this.password === null ||
          this.password === "" ||
          this.password.trim().length === 0
        ) {
          new ToastUtils().presentToast("Enter password");
          document.getElementById("password").setFocus();
        } else if (new ValidationUtils().password(this.password) === false) {
          new ToastUtils().presentToast(
            "Password must be 8 characters with atleast 1 Upper Case and 1 Special Character"
          );
          document.getElementById("password").setFocus();
        } else if (
          typeof this.retypePassword === "undefined" ||
          this.retypePassword === null ||
          this.retypePassword === "" ||
          this.retypePassword.trim().length === 0
        ) {
          new ToastUtils().presentToast("Retype password");
          document.getElementById("retypePassword").setFocus();
        } else if (
          new ValidationUtils().password(this.retypePassword) === false
        ) {
          new ToastUtils().presentToast(
            "Password must be 8 characters with atleast 1 Upper Case and 1 Special Character"
          );
          document.getElementById("retypePassword").setFocus();
        } else if (this.password !== this.retypePassword) {
          new ToastUtils().presentToast("Retype Password mismatch");
        } else if (
          typeof this.termsCons === "undefined" ||
          this.termsCons === null ||
          this.termsCons === false
        ) {
          new ToastUtils().presentToast(
            "Please agree to the Terms and Conditions"
          );
        } else {
          let user = await new AuthenticationService().signupUserWithCredentialProfile(
            new Credential(this.mobile, this.password),
            new Profile(
              this.firstName.trim(),
              this.lastName.trim(),
              new Gender(this.gender),
              new Date(this.dob)
            ),
            this.email.trim(),
            this.password
          );
          new ToastUtils().presentToast("OTP sent to your mobile number.");
          window.localStorage.setItem("user.id", user.id);
          window.localStorage.setItem("user.mobile", this.mobile);
          window.localStorage.setItem("user.password", this.password);

          this.$router.push("/signupverification");
        }
      } catch (error) {
        let serviceError = tryParseServiceError(error);
        if (serviceError.code === "U10001") {
          this.presentAlertConfirm(serviceError.description, "U");
        } else if (serviceError.code === "U10002") {
          this.presentAlertConfirm(serviceError.description, "C");
        } else {
          // new AlertUtils().presentAlert(serviceError ? serviceError : error);
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
        }
      }
    },
    async presentAlertConfirm(message, type) {
      //SCMT 2.0 Start
      // const alert = document.createElement("ion-alert");
      // alert.header = "Confirm";
      // alert.message = message;
      // alert.buttons = [
      //   {
      //     text: "NO",
      //     role: "cancel",
      //     cssClass: "secondary",
      //     handler: () => {
      //       // console.log("Confirm Cancel");
      //     }
      //   },
      //   {
      //     text: "YES",
      //     handler: () => {
      //       this.overrideSignup(type);
      //     }
      //   }
      // ];

      // document.body.appendChild(alert);
      // return alert.present();

      //SCMT 2.0 End

      return alertController.create({
        header : "Confirm",
        message : message,
        buttons : [
        {
          text: "NO",
          role: "cancel",
          cssClass: "secondary",
          handler: () => {
            // console.log("Confirm Cancel");
          }
        },
        {
          text: "YES",
          handler: () => {
            this.overrideSignup(type);
          }
        }
      ]
      }).then(res => res.present()); 
    },
    async overrideSignup(type) {
      //SCMT 2.0 Start
      // let user = await new AuthenticationService().signupUserByOverritingExistingAccountWithCredentialProfile(
      //   new Credential(this.mobile, this.password),
      //   new Profile(
      //     this.firstName.trim(),
      //     this.lastName.trim(),
      //     new Gender(this.gender),
      //     new Date(this.dob)
      //   ),
      //   this.email.trim(),
      //   this.password
      // );
      //SCMT 2.0 End
      let user = await new AuthenticationService().newsignupUserByOverritingExistingAccountWithCredentialProfile(
        new NewCredential(this.mobile),
        new NewProfile(this.name.trim())
      );
      new ToastUtils().presentToast("OTP sent to your mobile number.");
      window.localStorage.setItem("user.id", user.id);
      window.localStorage.setItem("user.mobile", this.mobile);
      if (type === 'U') {
        window.localStorage.setItem("user.password", this.password);
      }

      this.$router.push("/signupverification");
    }
  }
});
</script>
  
<style scoped>
  /* a:link, a:visited, a:active {
    color: #474747;
    text-decoration: none;
  } */
 /* Reduce only this ion-item size */
 .terms-item {
  display: flex;
  justify-content: center;
}

.terms-condition {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.terms-item {
  --min-height: 2px;
  --padding-start: 0;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  
}

.terms-condition{
  font-size: 13px;
  align-items: center;
  /* margin-right: 16px; */
}

.terms-item ion-checkbox {
  --size: 13px;
  margin-right: 6px;
  --checkbox-background-checked: #21b24b;
}
ion-checkbox::part(container) {
  border-radius: 3px;
  border: 2px solid #21b24b;
  margin: 0;
}

ion-checkbox::part(label) {
  margin: 5px;
}


  .t-c {
    display: block;
    position: relative;
    padding-left: 45px;
    margin-bottom: 12px;
    cursor: pointer;
    text-align: left;
    font-family: "Roboto";
    font-size: 15px;
    letter-spacing: 0;
    opacity: 1;
  }
  
  /* ion-checkbox {
    display: inline-block;
    position: absolute;
    width: 26px;
    height: 27px;
    --background: #ffffff 0% 0% no-repeat padding-box;
    --border: 1px solid #00000080;
    --border-radius: 4px;
    --border-color-checked: #00000080;
    --background-checked: #ffffff 0% 0% no-repeat padding-box;
    --checkmark-color: #21b24b;
    opacity: 1;
  } */
  
  .t-c .dark-text {
    color: #8a8a8a;
  }

  .termColor{
    color: rgb(11, 11, 203);
  }
  .dark-text {
    /* color: #8a8a8a; */
    font-size: 11px;
  }
  .signIn {
    cursor: pointer;
    color: #1fe080;
    font-weight: bold;
  }
  .accept-terms {
    font-size: 13px;
    margin-top: 0px;
  }
</style>